import { useState } from "react";
import { ExternalLink } from "lucide-react";
import "./Portfolio.css";

/* ─── Local image imports ────────────────────────────────────
   Portfolio.jsx lives at src/components/home/
   so assets are two levels up: ../../assets/images/          */
import threeD1    from "../../assets/images/threeD1.jpg";
import threeD2    from "../../assets/images/threeD2.jpeg";
import brand1     from "../../assets/images/brand1.jpeg";
import brand2     from "../../assets/images/brand2.jpeg";
import bags1      from "../../assets/images/bags1.jpg";
import boxes      from "../../assets/images/boxes.jpeg";
import bdCard     from "../../assets/images/bdCard.jpg";
import brochure   from "../../assets/images/brochure.jpg";
import flyers     from "../../assets/images/flyers.jpg";
import tshirt     from "../../assets/images/tshirt.jpg";
import caps       from "../../assets/images/Caps.jpg";
import book1      from "../../assets/images/book1.jpeg";
import book2      from "../../assets/images/book2.jpeg";
import largeFormatImg from "../../assets/images/largeFormat.jpeg";
import wristband  from "../../assets/images/wristband.jpg";
import brand4     from "../../assets/images/brand4.jpg";

/* ─── Portfolio data ─────────────────────────────────────────
   Layout on a 12-column grid, row height = 116px:

   [3D Signage — c3 r4] [Packaging — c3 r2] [Branding — c3 r2] [Web/LF — c3 r4]
                         [Printing  — c3 r2] [Merch    — c3 r2]
                                                                                   */
const PORTFOLIO = [
  {
    img: threeD2,
    cat: "3D Signage",
    title: "Illuminated Shop Front",
    span: "c3 r4",
  },
  {
    img: bags1,
    cat: "Packaging",
    title: "Branded Paper Bags",
    span: "c3 r2",
  },
  {
    img: brand1,
    cat: "Brand Identity",
    title: "Corporate Identity System",
    span: "c3 r2",
  },
  {
    img: largeFormatImg,
    cat: "Large Format",
    title: "Banner & Rollup Production",
    span: "c3 r4",
  },
  {
    img: brochure,
    cat: "Printing",
    title: "Brochure & Stationery Suite",
    span: "c3 r2",
  },
  {
    img: tshirt,
    cat: "Promotional Merch",
    title: "Branded T-Shirts & Caps",
    span: "c3 r2",
  },
];

export default function Portfolio() {
  const [hov, setHov] = useState(null);

  return (
    <section className="port-sec" aria-label="Portfolio">

      <div className="port-head">
        <div className="port-eyebrow">
          <span className="port-dot" />
          Featured Work
        </div>
        <h2 className="port-h2">
          Projects We're <em className="port-em">Proud Of</em>
        </h2>
      </div>

      <div className="port-bento">
        {PORTFOLIO.map((p, i) => (
          <div
            key={p.title}
            className={`port-card ${p.span}`}
            onMouseEnter={() => setHov(i)}
            onMouseLeave={() => setHov(null)}
            role="img"
            aria-label={`${p.cat}: ${p.title}`}
          >
            <img
              className="port-card__img"
              src={p.img}
              alt={p.title}
              loading={i < 2 ? "eager" : "lazy"}
            />
            <div className={`port-card__ov${hov === i ? " hov" : ""}`}>
              <div className="port-card__cat">{p.cat}</div>
              <div className="port-card__title">{p.title}</div>
              <div className={`port-card__btn-wrap${hov === i ? " hov" : ""}`}>
                <button className="port-card__btn">
                  View Project <ExternalLink size={11} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

    </section>
  );
}